function header()
{
    const banner = document.querySelector('.banner');
    const main = document.getElementById('main');
    const heroElement = document.querySelector('.block-hero');
    const headerElement = document.querySelector('.block-header');

    if (!heroElement && !headerElement) {
        banner.classList.add('scrolled');
        main.classList.add('scrolled');
    } else {
        window.addEventListener('scroll', function () {
            if (window.scrollY > 0) {
                banner.classList.add('scrolled');
            } else {
                banner.classList.remove('scrolled');
            }
        });
    }


}

export { header };
